/**
 * AD-2653: reads Felicity's answer as it is written, so her first words show within a second or two.
 * The server sends each piece of text as an event; onText is given the whole answer so far.
 */
export const readAnswerStream = async (response, onText) => {
    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';
    let answer = '';

    for (;;) {
        const {done, value} = await reader.read();
        if (done) {
            break;
        }
        buffer += decoder.decode(value, {stream: true});

        let end = buffer.indexOf('\n\n');
        while (end !== -1) {
            const event = buffer.slice(0, end);
            buffer = buffer.slice(end + 2);
            end = buffer.indexOf('\n\n');

            const lines = event.split('\n');
            const name = lines.find(line => line.startsWith('event: '))?.slice(7);
            const data = lines.find(line => line.startsWith('data: '))?.slice(6);

            if (name === 'error') {
                throw new Error('stream');
            }
            if (name === 'done' || !data) {
                continue;
            }

            const text = JSON.parse(data).text;
            if (text) {
                answer += text;
                onText(answer);
            }
        }
    }

    if (!answer.trim()) {
        throw new Error('empty');
    }
    return answer;
};

/** The answer so far, without a mark Felicity has only half written, such as "[[SHO". */
export const shownSoFar = (answer) => answer.replace(/\[\[[^\]]*$/, '');
